<template>
  <v-layout row wrap align-center v-on:keyup.enter="queryDepartmentCourseInfo">
    <v-flex md2>
      <v-select
        :label="labels.college"
        v-model="selectCollege"
        :items="colleges"
        :item-text="collegeText[select_language.lang]"
        item-value="CollegeNo"
      ></v-select>
    </v-flex>
    <v-flex md2>
      <v-select
        :label="labels.department"
        v-model="selectDepartment"
        :items="departments"
        :item-text="departmentText[select_language.lang]"
        item-value="DeptNo"
      ></v-select>
    </v-flex>
    <v-flex md2>
      <v-text-field
        :label="labels.course_title"
        v-model="course_name"
      ></v-text-field>
    </v-flex>
    <v-flex md2>
      <v-text-field
        :label="labels.instructor"
        v-model="course_teacher"
      ></v-text-field>
    </v-flex>
    <v-flex md1 align-self-center>
      <v-checkbox
        :label="labels.eng_program"
        v-model="select_course_notes"
        value="eng"
      ></v-checkbox>
    </v-flex>
    <v-flex md1 align-self-center>
      <v-checkbox
        :label="labels.graduate_program"
        v-model="only_master"
      ></v-checkbox>
    </v-flex>
    <v-flex md1 align-self-center>
      <v-checkbox
        :label="labels.under_graduate_program"
        v-model="only_under_graduate"
      ></v-checkbox>
    </v-flex>
    <v-flex md1>
      <v-btn
        round
        :disabled="btn_state"
        v-on:click="queryDepartmentCourseInfo()"
      >
        <v-icon>search</v-icon>
        {{ labels.search }}
      </v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
import languages from "../../languages/TabDepartment.json";

export default {
  data: () => ({
    labels: {
      college: "",
      department: "",
      course_title: "",
      instructor: "",
      eng_program: "",
      graduate_program: "",
      under_graduate_program: "",
      search: "",
    },
    colleges: [],
    collegeText: { zh: "CollegeName", en: "CollegeEngName" },
    selectCollege: "",
    departments: [],
    departmentText: { zh: "Department", en: "EngDepartment" },
    select: "",
    course_name: "",
    select_course_notes: [],
    only_master: "",
    only_under_graduate: "",
    course_teacher: "",
  }),
  computed: {
    btn_state() {
      return this.$store.state.btn_state;
    },
    selectDepartment: {
      get() {
        return this.$store.state.selectDepartment;
      },
      set(value) {
        this.$store.commit("setSelectDepartment", value);
      },
    },
    select_language() {
      return this.$store.state.select_language;
    },
  },
  watch: {
    select_language(value) {
      this.setLanguage(value);
    },
    selectCollege(value) {
      fetch("api/departments?collegeNo=" + String(value))
        .then((response) => response.json())
        .then((data) => {
          this.departments = data;
          this.selectDepartment = "";
        });
    },
  },
  created() {
    this.setLanguage(this.$store.state.select_language);
  },
  mounted() {
    fetch("api/Colleges/")
      .then((response) => response.json())
      .then((data) => (this.colleges = data));
  },
  methods: {
    queryDepartmentCourseInfo: function() {
      if (this.selectDepartment == "") {
        this.$store.commit("setAlertState", true);
        this.$store.commit("setAlertMessage", "請選擇學院及系所學程");
      } else {
        var query_params = {
          Semester: this.$store.state.select_semester,
          CourseNo: this.$store.state.selectDepartment,
          CourseName: this.course_name,
          CourseTeacher: this.course_teacher,
          Dimension: "",
          CourseNotes: this.select_course_notes,
          ForeignLanguage: 0,
          OnlyGeneral: 0,
          OnleyNTUST: 0,
          OnlyUnderGraduate: this.only_under_graduate * 1,
          OnlyMaster: this.only_master * 1,
          Language: this.select_language.lang,
        };
        this.$store.dispatch("queryCourseInfo", query_params);
      }
    },
    setLanguage: function(select_language) {
      this.labels.college = languages.college[select_language.lang];
      this.labels.department = languages.department[select_language.lang];
      this.labels.course_title = languages.course_title[select_language.lang];
      this.labels.instructor = languages.instructor[select_language.lang];
      this.labels.search = languages.search[select_language.lang];
      this.labels.eng_program = languages.eng_program[select_language.lang];
      this.labels.graduate_program =
        languages.graduate_program[select_language.lang];
      this.labels.under_graduate_program =
        languages.under_graduate_program[select_language.lang];
      this.select = languages.select[select_language.lang];
    },
  },
};
</script>
